
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetojejuricab() {



    const cardData =
    {
        keyword: 'Pune to Jejuri Cab',
        heading: 'Meghana Cab : Pune to Jejuri Cab',
        headingDescription: 'Meghana Cab offers Pune to Jejuri Cab services, ensuring a smooth and spiritual journey to the famous Khandoba Temple. Whether you’re planning a religious visit, family trip, or weekend outing, our clean and comfortable cabs with experienced drivers provide a safe and pleasant travel experience. Benefit from on-time pickups, affordable pricing, and 24/7 support with Meghana Cab. Book your Pune to Jejuri Cab today and enjoy a peaceful and hassle-free ride to one of Maharashtra’s most revered pilgrimage destinations.',


        top: 'Top Places to Visit in Jejuri with Meghana Cab',

"topPlaces": [
  {
    "title": "Khandoba Temple (Gad Kot)",
    "description": "The iconic hill‑top shrine dedicated to Lord Khandoba — a popular folk‑Shiva deity revered by Dhangars, Lingayats, and local communities. Built originally in the 12th–13th century and later expanded by the Marathas (including Chimaji Appa’s trophies), the temple complex features a grand gate, deep‑stambhas (lamp pillars), Nandi statue, water tanks, and roughly 450 steps. During the famous Somvati Amavasya and Bhandara festival, overwhelming clouds of turmeric (haridra) transform the temple and its devotees into golden realms — a spectacle of faith and color :contentReference[oaicite:2]{index=2}."
  },
  {
    "title": "Kadepathar Temple & Jejuri Fort",
    "description": "Perched above the main temple, this older fort‑style shrine requires climbing steep 750 steps to the rocky summit. Offering panoramic views of Jejuri town, the Karha river valley, and the undulating Sahyadris, this site is steeped in Maratha lore — including fortifications where Khandoba was believed to have ruled and hosted legendary battles :contentReference[oaicite:3]{index=3}."
  },
  {
    "title": "Brahma Kund & Hill‑side Water Structures",
    "description": "Nestled on the temple hill’s slopes, Brahma Kund is a historic stepped water reservoir used for ritual cleansing and daily ablutions. Often overlooked by tourists, this peaceful spot reveals traditional Maratha hill‑side engineering and offers a serene contrast to the busy temple precincts above :contentReference[oaicite:4]{index=4}."
  },
  {
    "title": "Jeevanand Falls & Ghat",
    "description": "Located a short distance from the hill temple, Jeevanand Falls and its river‑bank ghat provide a shaded, tranquil retreat. Ideal for brief nature walks, devotional dips, or quiet reflection, this area complements the spiritual journey with cool water, birdsong, and riverside ambience :contentReference[oaicite:5]{index=5}."
  }
],

"services": [
    {
        "name": "Cab Booking Pune to Jejuri",
        "description": "Book a convenient and reliable cab from Pune to Jejuri with Meghana Cab. Enjoy comfortable rides with punctual pickups and professional drivers, perfect for your spiritual journey to Jejuri Temple."
    },
    {
        "name": "One Way Cab to Jejuri Temple",
        "description": "Travel one-way from Pune to Jejuri Temple with Meghana Cab’s hassle-free service. Ideal for quick religious visits, our cabs provide safe and timely transportation to this revered destination."
    },
    {
        "name": "Round Trip Taxi Pune to Jejuri",
        "description": "Plan your round trip from Pune to Jejuri with Meghana Cab. Our flexible scheduling and affordable round-trip options make it easy to enjoy your pilgrimage without transportation worries."
    },
    {
        "name": "AC Cab from Pune to Jejuri",
        "description": "Stay comfortable on your Pune to Jejuri journey with Meghana Cab’s air-conditioned cabs. Perfect for warm weather travel, our AC vehicles ensure a refreshing and smooth ride."
    },
    {
        "name": "Affordable Cab Hire Pune to Jejuri",
        "description": "Looking for budget-friendly cab options from Pune to Jejuri? Meghana Cab offers affordable rates without compromising on vehicle quality or driver professionalism."
    },
    {
        "name": "Pune to Jejuri Religious Trip Taxi",
        "description": "Make your religious trip to Jejuri peaceful and comfortable with Meghana Cab. We provide dedicated taxi services for temple visits, ensuring timely arrivals and safe returns."
    },
    {
        "name": "Jeep Cab to Jejuri from Pune",
        "description": "For rugged terrain or group travel, book a Jeep cab from Pune to Jejuri with Meghana Cab. Our well-maintained Jeeps offer sturdy and comfortable travel on hill roads."
    },
    {
        "name": "Sedan Hire Pune to Jejuri",
        "description": "Opt for a stylish and comfortable sedan hire from Pune to Jejuri. Meghana Cab’s sedans provide a smooth ride ideal for solo travelers or small groups visiting the temple."
    },
    {
        "name": "SUV Pune to Jejuri Taxi",
        "description": "Travel with extra space and comfort by booking an SUV taxi from Pune to Jejuri. Perfect for families and groups, our SUVs handle the road well and provide ample luggage capacity."
    },
    {
        "name": "Online Cab for Jejuri Darshan",
        "description": "Easily book your online cab for Jejuri Darshan with Meghana Cab. Our streamlined booking process makes planning your temple visit simple and efficient."
    },
    {
        "name": "Pune to Jejuri Temple Visit Cab",
        "description": "Ensure a hassle-free visit to Jejuri Temple with Meghana Cab’s dedicated taxi service. Experience punctual pickups, clean vehicles, and courteous drivers familiar with the local area."
    },
    {
        "name": "Outstation Cabs for Jejuri",
        "description": "Meghana Cab offers outstation cab services for Pune to Jejuri travel, providing reliable transportation for longer trips and group travel with comfort and safety."
    },
    {
        "name": "Pune to Jejuri Private Taxi",
        "description": "Book a private taxi from Pune to Jejuri for a personalized and flexible travel experience. Meghana Cab ensures privacy, comfort, and on-time service."
    },
    {
        "name": "Pune to Jejuri Cab Fare",
        "description": "Get transparent and competitive cab fare estimates for Pune to Jejuri trips with Meghana Cab. We offer affordable pricing with no hidden charges."
    },
    {
        "name": "Local Driver for Pune to Jejuri Cab",
        "description": "Hire a knowledgeable local driver for your Pune to Jejuri cab service. Our drivers are well-versed with the routes and customs, enhancing your travel experience."
    }
],

"tableData": [
    ["Cab Booking Pune to Jejuri", "One Way Cab to Jejuri Temple"],
    ["Round Trip Taxi Pune to Jejuri", "AC Cab from Pune to Jejuri"],
    ["Affordable Cab Hire Pune to Jejuri", "Pune to Jejuri Religious Trip Taxi"],
    ["Jeep Cab to Jejuri from Pune", "Sedan Hire Pune to Jejuri"],
    ["SUV Pune to Jejuri Taxi", "Online Cab for Jejuri Darshan"],
    ["Pune to Jejuri Temple Visit Cab", "Outstation Cabs for Jejuri"],
    ["Pune to Jejuri Private Taxi", "Pune to Jejuri Cab Fare"],
    ["Local Driver for Pune to Jejuri Cab", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Jejuri Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a smooth and convenient cab service from Pune to Jejuri, perfect for temple visits, family trips, or spiritual journeys. Enjoy a peaceful ride in our clean and well-maintained vehicles."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop for Jejuri Darshan",
        "WhyChoosedescription": "Punctuality matters, especially for religious trips. Our Pune to Jejuri cab service ensures timely pick-up and drop so you can attend poojas or darshan without any delay."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Journey",
        "WhyChoosedescription": "Our drivers are courteous, professional, and well-versed with the Pune to Jejuri route. They ensure a safe, comfortable, and stress-free ride with full respect for your devotional travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Cab Fare",
        "WhyChoosedescription": "Get the best value with our budget-friendly Pune to Jejuri cab pricing. We offer transparent fares with no hidden charges, so you can plan your spiritual trip without financial worries."
    },
    {
        "WhyChooseheading": "Clean, Safe, and Sanitized Vehicles",
        "WhyChoosedescription": "All our cabs are regularly cleaned, sanitized, and equipped with safety features like seat belts and GPS tracking, ensuring a hygienic and secure travel experience to Jejuri."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Jejuri Travel",
        "WhyChoosedescription": "Whether it's an early morning temple visit or an evening return, Meghana Cab operates 24/7, offering flexible travel times for your Pune to Jejuri journey."
    },
    {
        "WhyChooseheading": "Custom Travel Options for Pilgrimage",
        "WhyChoosedescription": "We understand that temple trips may require extra time or stops. Meghana Cab offers customizable packages and travel plans to suit your spiritual and personal needs."
    },
    {
        "WhyChooseheading": "Easy Booking and Devoted Customer Support",
        "WhyChoosedescription": "Booking your Pune to Jejuri cab is quick and easy through our website or mobile app. For any special requirements or questions, our customer support team is always here to help."
    }
]





















    }

const faqData = [
    {
        question: "How can I book a Pune to Jejuri cab with Meghana Cab?",
        answer: "Booking a Pune to Jejuri cab is easy through Meghana Cab’s website or by calling us directly at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Jejuri trips?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and comfort preferences."
    },
    {
        question: "How long does it take to travel from Pune to Jejuri by cab?",
        answer: "The journey from Pune to Jejuri usually takes about 1 to 1.5 hours depending on traffic and road conditions."
    },
    {
        question: "Is one-way cab service available from Pune to Jejuri?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip cab services between Pune and Jejuri."
    },
    {
        question: "Are tolls and parking charges included in the fare?",
        answer: "Toll and parking fees are additional and clearly communicated during the booking process."
    },
    {
        question: "Are your drivers experienced on the Pune to Jejuri route?",
        answer: "Yes, all our drivers are professional and well-versed with the local routes including Pune to Jejuri."
    },
    {
        question: "Can I request stops during the Pune to Jejuri cab journey?",
        answer: "Yes, you can request stops along the way. Please inform us while booking to make necessary arrangements."
    },
    {
        question: "Is the Pune to Jejuri cab service available 24/7?",
        answer: "Absolutely. Meghana Cab operates round the clock, so you can book your cab at any time."
    },
    {
        question: "What payment methods are accepted for Pune to Jejuri bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Jejuri cab bookings?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ajinkya Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Jejuri cab service from Meghana Cab was excellent. The driver was punctual and the ride was comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a wonderful experience with Meghana Cab for my Pune to Jejuri trip. The booking was easy and the driver was friendly and professional.”',
    },
];
















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jejuri Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-jejuri-cab.jpg",
  "description": "Book Pune to Jejuri cab with Meghana Cabs for one-way and round trips. Comfortable AC, SUV, and sedan taxis available for religious trips, temple visits, and private travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5234"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-jejuri-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Pune to Jejuri Cab | Temple Trip & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Jejuri cab with Meghana Cabs for one-way and round trips. Comfortable AC, SUV, and sedan taxis available for religious trips, temple visits, and private travel." 
  />
  <meta 
    name="keywords" 
    content="Cab Booking Pune to Jejuri, One Way Cab to Jejuri Temple, Round Trip Taxi Pune to Jejuri, AC Cab from Pune to Jejuri, Affordable Cab Hire Pune to Jejuri, Pune to Jejuri Religious Trip Taxi, Jeep Cab to Jejuri from Pune, Sedan Hire Pune to Jejuri, SUV Pune to Jejuri Taxi, Online Cab for Jejuri Darshan, Pune to Jejuri Temple Visit Cab, Outstation Cabs for Jejuri, Pune to Jejuri Private Taxi, Pune to Jejuri Cab Fare, Local Driver for Pune to Jejuri Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetojejuricab;